import { observer } from 'mobx-react';
import ProductLicenses from './ProductLicenses';

function Nav() {
  return (
    <div className="flex">
      <ProductLicenses />
    </div>
  );
}

export default observer(Nav);
